import { Fragment } from "react"
import { localizeDateTime } from "../../utils"

import { Flex, Heading, Stack, Text } from "@chakra-ui/react"

const OrderProperty = ({ label, id, children }) => (
  <Flex id={id}>
    <Text as="strong" flex="1">
      {label}
    </Text>
    <Text>{children}</Text>
  </Flex>
)

const OrderLine = ({ line }) => (
  <Flex px={4} py={2} borderRadius="md" bg="gray.100">
    <Text as="strong">{line.qty}&nbsp;x&nbsp;</Text>
    <Text flex="1">{line.name}</Text>
    <Text>{line.price}&nbsp;€</Text>
  </Flex>
)

const OrderDetail = ({ order, frescoLines, gastroLines }) => (
  <Fragment>
    <Heading align="center" as="h4" size="xm" color="gray.500" mt={4}>
      Ordine n.
    </Heading>
    <Heading align="center" as="h1" size="4xl" mb={4}>
      {order.orderId}
    </Heading>
    <Stack spacing={2}>
      <OrderProperty label="Data">
        {localizeDateTime(order.timestamp)}
      </OrderProperty>
      <OrderProperty label="Nome">{order.name}</OrderProperty>
      <OrderProperty label="Cognome">{order.surname}</OrderProperty>
      <OrderProperty label="Telefono">{order.phone}</OrderProperty>
      <OrderProperty label="Email">{order.email}</OrderProperty>
      <OrderProperty label="Comune">{order.cityName}</OrderProperty>
      <OrderProperty label="Indirizzo">{order.address}</OrderProperty>
    </Stack>

    <Heading align="center" as="h4" size="md" mt={8} mb={4}>
      Fresco
    </Heading>
    <Stack spacing={2}>
      {frescoLines.length ? (
        frescoLines.map((line) => <OrderLine key={line.id} line={line} />)
      ) : (
        <Text as="em" fontSize="sm" color="gray.500" textAlign="center">
          Nessun prodotto Fresco ordinato
        </Text>
      )}
    </Stack>

    <Heading align="center" as="h4" size="md" mt={8} mb={4}>
      Gastronomia
    </Heading>
    <Stack spacing={2}>
      {gastroLines.length ? (
        <Fragment>
          {gastroLines.map((line) => (
            <OrderLine key={line.id} line={line} />
          ))}
          <Flex px={4} py={2}>
            <Text as="strong" flex="1">
              Totale
            </Text>
            <Text>
              {gastroLines.reduce((total, line) => {
                return (
                  total +
                  parseFloat(line.price || 0) * parseFloat(line.qty || 0)
                )
              }, 0.0)}
              &nbsp;€
            </Text>
          </Flex>
        </Fragment>
      ) : (
        <Text as="em" fontSize="sm" color="gray.500" textAlign="center">
          Nessun prodotto Gastronomia ordinato
        </Text>
      )}
    </Stack>
  </Fragment>
)

export default OrderDetail
